import React, { FC } from "react";
import { SimpleMDEReactProps } from "react-simplemde-editor";
import "easymde/dist/easymde.min.css";

import { StyledMarkdownEditor } from "../styled";

export const MarkdownEditor: FC<SimpleMDEReactProps> = props => <StyledMarkdownEditor {...props} />;
